<nz-spin [nzSpinning]="loading$ | async">
  <form [formGroup]="mainForm" class="form" nzLayout="vertical">
    <div class="drawer-form-wrapper">
      <nz-tabset [(nzSelectedIndex)]="currentTabIndex">
        <nz-tab
          *ngFor="let tab of tabs; let i = index"
          [nzTitle]="tab.title"
          [nzDisabled]="isTabDisabled(i)">
          <ng-container [ngSwitch]="tab.key">
            <ng-container
              *ngIf="{
                languageLevel: languageLevel$ | async,
                behaviourResuorceType: behaviourResuorceType$ | async,
                behaviourReplacementType: behaviourReplacementType$ | async,
                behaviourSupervisionType: behaviourSupervisionType$ | async,
              } as data">
              <app-strategy-details
                *ngSwitchCase="'details'"
                [detailsForm]="detailsFormGroup"
                [languageLevel]="data.languageLevel || []"
                [behaviourResuorceType]="data.behaviourResuorceType || []"
                [behaviourReplacementType]="data.behaviourReplacementType || []"
                [behaviourSupervisionType]="
                  data.behaviourSupervisionType || []
                " />
            </ng-container>
            <ng-container
              *ngIf="{
                environments: environments$ | async,
                ageLevels: ageLevels$ | async,
                functions: functions$ | async,
                settingEvents: settingEvents$ | async,
                antecedents: antecedents$ | async,
                languageLevel: languageLevel$ | async,
                behaviourConsequence: behaviourConsequence$ | async,
              } as data">
              <app-additional-predicates
                *ngSwitchCase="'predicates'"
                [predicatesForm]="predicatesFormGroup"
                [environments]="data.environments || []"
                [ageLevels]="data.ageLevels || []"
                [functions]="data.functions || []"
                [settingEvents]="data.settingEvents || []"
                [antecedents]="data.antecedents || []"
                [languageLevel]="data.languageLevel || []"
                [behaviourConsequence]="data.behaviourConsequence || []" />
            </ng-container>
            <app-guidelines
              *ngSwitchCase="'guidelines'"
              [guidelineForm]="guidelineFormGroup" />

            <app-detail-prompts
              *ngSwitchCase="'prompts'"
              [promptsForm]="promptsFormGroup" />
          </ng-container>
        </nz-tab>
      </nz-tabset>
    </div>

    <div class="drawer-footer display-flex justify-content-between">
      <button nz-button nzType="default" (click)="closeDrawer()">Cancel</button>
      <button
        nz-button
        nzType="primary"
        (click)="onNext()"
        [disabled]="!canProceedToNextStep()">
        {{ getButtonText() }}
      </button>
    </div>
  </form>
</nz-spin>
